/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why an import row was skipped; the frontend maps each code to its own text.
 * @export
 */
export const UserImportSkipReason = {
    InvalidEmail: 'invalid_email',
    EmailTaken: 'email_taken',
    UsernameInvalid: 'username_invalid',
    UsernameTaken: 'username_taken'
} as const;
export type UserImportSkipReason = typeof UserImportSkipReason[keyof typeof UserImportSkipReason];


export function instanceOfUserImportSkipReason(value: any): boolean {
    for (const key in UserImportSkipReason) {
        if (Object.prototype.hasOwnProperty.call(UserImportSkipReason, key)) {
            if (UserImportSkipReason[key as keyof typeof UserImportSkipReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserImportSkipReasonFromJSON(json: any): UserImportSkipReason {
    return UserImportSkipReasonFromJSONTyped(json, false);
}

export function UserImportSkipReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserImportSkipReason {
    return json as UserImportSkipReason;
}

export function UserImportSkipReasonToJSON(value?: UserImportSkipReason | null): any {
    return value as any;
}

export function UserImportSkipReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): UserImportSkipReason {
    return value as UserImportSkipReason;
}

